/* eslint-disable */
import { ISupportDesk, ISupportData } from 'src/interfaces';
import http from './http';
import axios, { AxiosError } from 'axios';

class ChatFaqService {
  static getSupportTickets(params: any): Promise<{ items: ISupportDesk[]; meta: { totalItems: number } }> {
    let stringParams = '';
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http
      .get(`support-ticket?${stringParams}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static getAllFaqs(params: any): Promise<{ items: any[] }> {
    return http
      .get(`faqs`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data.data);
  }

  static deleteFaq(faqId: any): Promise<{}> {
    console.log('faqId', faqId);
    return http.delete(`faqs/${faqId}`, {
      headers: { companyId: '' },
    });
  }

  static updateSupportTicket(ticketId: string, updateData: any) {
    return http
      .patch(`/support-ticket/crm-support-tickets/support-ticket-status/${ticketId}`, updateData, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static addFaq(faq: any) {
    return http
      .post(`/faqs`, faq, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateFaq(faqId: string, faq: any) {
    return http
      .put(`/faqs/${faqId}`, faq, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}
export default ChatFaqService;
